import React from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  Autocomplete,
  Chip,
} from "@mui/material";
import { inviteProviderValidationSchema } from "../../services/validator";
import { specialties } from "../../helpers/ specialties";
import useEncryption from "../../services/useEncryption";
import useToast from "../../helpers/useToast";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import path from "../../path";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { inviteProviderApi } from "../../api/adminApi/adminApi";
import useHeaders from "../../helpers/useHeaders";

function InviteProvider({ onInviteSent, onCancel, setValue }) {
  const navigate = useNavigate();
  const initialValues = {
    organizationName: "",
    // organizationType: "",
    // phoneNumber: "",
    email: "",
  };

  const validationSchema = inviteProviderValidationSchema;
  const { encryptData, decryptData } = useEncryption();
  const toastOptions = useToast();
  const headers = useHeaders();

  const onSubmit = async (values, { resetForm }) => {
    try {
      const modifiedValues = {
        ...values,
        createdBy: "admin",
      };
      const data = encryptData(modifiedValues);
      const response = await inviteProviderApi(data, headers);
      toast.success(response.data.message, toastOptions);
      onInviteSent();
      resetForm();
      setValue(0);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, toastOptions);
    }
  };

  const Formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <Box sx={styles.Container}>
      <form onSubmit={Formik.handleSubmit}>
        <Box>
          <TextField
            name="organizationName"
            label="Location Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={Formik.values.organizationName}
            onChange={Formik.handleChange}
            onBlur={Formik.handleBlur}
            error={
              Formik.touched.organizationName &&
              Boolean(Formik.errors.organizationName)
            }
            helperText={
              Formik.touched.organizationName && Formik.errors.organizationName
            }
          />

          {/* <TextField
            name="organizationType"
            label="Organization Type"
            variant="outlined"
            fullWidth
            margin="normal"
            value={Formik.values.organizationType}
            onChange={Formik.handleChange}
            onBlur={Formik.handleBlur}
            error={
              Formik.touched.organizationType &&
              Boolean(Formik.errors.organizationType)
            }
            helperText={
              Formik.touched.organizationType && Formik.errors.organizationType
            }
          /> */}

          {/* <TextField
            name="phoneNumber"
            label="Phone Number"
            variant="outlined"
            fullWidth
            margin="normal"
            value={Formik.values.phoneNumber}
            onChange={Formik.handleChange}
            onBlur={Formik.handleBlur}
            error={
              Formik.touched.phoneNumber && Boolean(Formik.errors.phoneNumber)
            }
            helperText={Formik.touched.phoneNumber && Formik.errors.phoneNumber}
          /> */}

          <TextField
            name="email"
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={Formik.values.email}
            onChange={Formik.handleChange}
            onBlur={Formik.handleBlur}
            error={Formik.touched.email && Boolean(Formik.errors.email)}
            helperText={Formik.touched.email && Formik.errors.email}
          />
          <box>
            <div className="text-end modalactions border-unset">
              <button
                className="btn btn-blacked outline me-2"
                onClick={() => {
                  onCancel();
                }}
              >
                Cancel
              </button>
              <button className="btn btn-blacked" type="submit">
                Submit
              </button>
            </div>
          </box>
        </Box>
      </form>
    </Box>
  );
}

/** @type {import("@mui/material").SxProps} */
const styles = {
  container: {
    width: "100%",
    margin: "0 auto",
    padding: "20px",
  },
  formCss: {
    width: "100%",
    maxWidth: 400,
    margin: "0 auto",
  },
};

export default InviteProvider;
